<template>
  <router-link tag="div" class="border-bottom card-wrap" :to="(data.type_text == 1?'/play/'+data.id+'/'+data.video_ids:'/systematic/'+data.id)">
    <div class="left">
      <img v-lazy="data.icon" alt="">
    </div>
    <div class="right">
      <div class="title"><span v-html="data.title"><!-- 标题 --></span><span class="browser">{{data.browses}}人在看</span></div>
      <div class="teacher" v-html="data.user_name"></div>
      <div class="label">
        <span v-if="data.section && (data.type === 2 || data.type === '体系课' || data.type_text === 2)">{{data.section}}节</span>
        <span v-else-if="(data.type === 1 || data.type === '微课' || data.type_text === 1)">VIP免费</span>
        <!-- 后台说用这个字段 -->
        <span v-if="data.istop_text || data.istop">精品课程</span>
        <!-- <span>限时免费</span> -->
      </div>
      <div class="countdown">{{data.promotion_name}} {{str}}</div>
      <div class="price">
        <span class="origin" v-if="data.is_promotion">￥<s>{{data.price}}</s></span>
        <span class="now"><span>￥</span>{{data.is_promotion ?data.promotion_price:data.price}}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
import {getRemaining} from '@/utils/dateUtil'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timer: null,
      str: '' // 倒计时的字符串
    }
  },
  computed: {
  },
  created() {
    if (this.data.is_promotion && this.data.promotion_enddate) {
      this.start(this.data.promotion_enddate)
    }
  },
  beforeDestroy() {
    // 清除定时器
    this.end()
  },
  methods: {
    start(future) {
      if (!this.timer) {
        const func = () => {
          const now = parseInt(new Date().getTime() / 1000)
          this.str = getRemaining(future - now)
        }
        func()
        this.timer = setInterval(func, 1000)
      }
    },
    end() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.str = ''
      }
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .border-bottom{
    &:last-child{
      &:before{
        display none
      }
    }
  }
  .card-wrap{
    padding size(34) 0
    display flex
  }
  .left{
    width percentage(150/690)
    height size(176)
    border-radius 4px
    overflow hidden
    img{
      display block
      width 100%
      height 100%
    }
  }
  .right{
    width percentage((690 - 150)/690)
    padding-left size(22)
    position relative
    .title{
      width 100%
      font-size size(32)
      // font-weight 800
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      padding-right size(120)
      position relative
      line-height 1.1
      color #161616
      .browser{
        color #8a8a8a
        font-size size(18)
        position absolute
        right 0
        top 50%
        font-weight 500
        margin-top size(-9)
      }
    }
    .teacher{
      font-size size(24)
      color #8a8a8a
      padding-top  size(20)
      padding-bottom size(20)
    }
    .label{
      font-size 0
      height 16px
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      span{
        display inline-block
        background $color-light
        color #fff
        font-size 10px
        padding size(0) size(8)
        line-height 17px
        height 16px
        border-radius 2px
        margin-right size(8)
      }
    }
    .countdown{
      font-size size(22)
      color $color-light
      margin-top size(20)
    }
    .price{
      position absolute
      right size(8)
      bottom size(24)
      .origin{
        color #b2b2b2
        font-size size(18)
        s{
          font-size size(22)
        }
      }
      .now{
        color $color-light
        font-size size(30)
        font-weight 800
        span{
          font-size size(18)
          position relative
          top size(-10)
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/card/card-course.vue